import { useEffect, useRef } from "react";
import { useAuthStore, selectUser } from "@safers/auth";
import { usePushSubscription, resetPushSubscription } from "./usePushSubscription";

export function useAutoPushSubscribe() {
  const user = useAuthStore(selectUser);
  const { subscribe } = usePushSubscription(null);
  const attemptedForRef = useRef<string | null>(null);

  useEffect(() => {
    if (!user) {
      attemptedForRef.current = null;
      resetPushSubscription();
      return;
    }
    if (typeof window === "undefined" || !("Notification" in window)) return;
    if (attemptedForRef.current === user.username) return;
    attemptedForRef.current = user.username;
    resetPushSubscription();
    if (Notification.permission !== "granted") return;

    let cancelled = false;
    void subscribe().then((ok) => {
      if (!ok && !cancelled) attemptedForRef.current = null;
    });
    return () => {
      cancelled = true;
    };
  }, [user, subscribe]);
}
